import 'element-plus/dist/index.css'
import mitt from 'mitt'
import { createApp } from 'vue'
import vueDebounce from 'vue-debounce'
import { i18n } from 'locales'
import VueCookies from 'vue3-cookies'
import App from './App.vue'
import './index.css'
import AppComponents from './components'
import router from './router'
import store from './store'

const app = createApp(App)
const emitter = mitt()
app.provide('eventHub', emitter)
app.use(router)
app.use(store)
app.use(i18n)
app.use(VueCookies, {
  secure: true,
})
app.use(AppComponents)
app.use(vueDebounce, {
  defaultTime: '300ms',
})
app.mount('#app')
